import { ACTION_TYPE as types } from '../../constants/win-vest';

const initialState = {
  watchlist: []
}

export const watchlistReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WATCHLIST:
      return Object.assign({}, state, {
        watchlist: action.watchlist || state.watchlist
      });
    default:
      return state
  }
}
